import checkout from './checkout.json';
import global from './global.json';
import product from './product.json';
import urls from './urls.json';

export default { global, urls, product, checkout };
